import { format } from "date-fns"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { colors } from "../../../ui/colors"
import { ArrowLeftIcon } from "../../../ui/icons/arrow-left"
import { Layout } from "../../../ui/layout"
import { ButtonComponent } from "../../../ui/molecules/button/newButton"
import { Calendar } from "../../../ui/molecules/calendar"
import { MadfarmInput } from "../../../ui/molecules/input/newInput"
import { ProtocolSearch } from "../../../ui/molecules/ProtocolSearch"
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static"
import TextArea from "../../../ui/molecules/textArea"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import { EsitoBiosuisse, yes_no } from "../../../utils"
import { BioSuisseCreation, resetCreateStatus, setCreateCertificateDate, setCreateCertificateExpires, setCreateCertifiedProducts, setCreateCondition, setCreateCustomerId, setCreateDepartureProtocolSend, setCreateEntryProtocolRequest, setCreateEntryProtocolResponse, setCreateInspectionVisitId, setCreateNote, setCreateNoteCondition, setCreateResult } from "./slice"

export function AddCertificazioneBiosuisse() {
    const navigate = useNavigate()
    const sessionState = useAppSelector(state => state.session)
    const bioSuisse = useAppSelector(state => state.bioSuisse)
    const dispatch = useAppDispatch()
    const assignmentState = useAppSelector(state => state.assignment)
    const [visitOptions, setVisitOptions] = useState<{ value: string; label: string }[]>([]);
    const [showSuccess, setShowSuccess] = useState<boolean>(false)

    useEffect(() => {
        dispatch(setCreateCustomerId(sessionState.selected.customerId))
    }, [])

    useEffect(() => {
        if (assignmentState.getAllInspectionVisitStatus === 'successfully') {
            const visits = assignmentState.getAllInspectionVisitResponse?.data || [];
            const options = visits.map((visit) => ({
                value: visit.id,
                label: new Date(visit.effectiveVisitDate).toLocaleDateString('it-IT') + " " + (visit.reportProtocolInfo ? visit.reportProtocolInfo : ''),
            }));
            setVisitOptions(options);
        }
    }, [assignmentState.getAllInspectionVisitStatus]);

    useEffect(() => {
        if (bioSuisse.bioSuisseCreationStatus === 'successfully') {
            setShowSuccess(true)
            dispatch(resetCreateStatus())

        }
    }, [bioSuisse.bioSuisseCreationStatus])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
                navigate('/gestioneBioSuisse')
            }, 2500);
        }
    }, [showSuccess]);

    return (
        <Layout menuItem={MenuItems.GESTIONE_CLIENTI} breadcrumbItems={['Gestione Clienti', 'Gestione Biosuisse', 'Nuova Certificazione']}
            noPaddingLat
            headerLabel="Gestione Biosuisse"
            headerIcon={
                <ArrowLeftIcon onClick={() => navigate('/gestioneBiosuisse')} color={colors.brandPrimary[50]} size={0} />
            }
            headerChildren={
                <div className="flex items-center h-full w-full justify-end">
                    <ButtonComponent
                        iconPosition='off'
                        variant='solid'
                        color='orange'
                        size='sm'
                        label='Salva'
                        onClick={() =>
                            dispatch(BioSuisseCreation(bioSuisse.createCertificate))
                        }
                    />
                </div>
            }
        >
            {
                (showSuccess) &&
                <div className="mx-6 mb-2 mt-6 rounded-[12px] border border-[#86EFAC] bg-[#ECFDF3] px-5 py-4 text-left">
                    <span className="fieldsetTitle block text-[14px] font-semibold text-[#166534]">
                        Dati salvati correttamente.
                    </span>
                </div>
            }
            <div className="p-6">
                <div className="rounded-[16px] border border-neutral-200 bg-white shadow-sm overflow-hidden">
                    <div className="bg-brandPrimary-600 px-6 py-4">
                        <div className='text-left'>
                            <span className='rid-title text-white'>Biosuisse </span>
                            <span className='rid-title text-brandPrimary-200'>/</span>
                            <span className='rid-title text-brandPrimary-100'> Aggiungi Certificazione Biosuisse</span>
                        </div>
                    </div>
                    <div className="p-6">
                        <div className='pb-6 border-b border-neutral-200'>
                            <ProtocolSearch
                                label="Richiesta Certificazione"
                                type='entry'
                                onSelect={(value) => {
                                    dispatch(setCreateEntryProtocolRequest(value))
                                }}
                            />
                        </div>
                        <div className='py-6 border-b border-neutral-200 grid grid-cols-1 md:grid-cols-2 gap-4'>
                            <MadfarmStaticSelect
                                label="Esito"
                                placeholder={'Esito'}
                                options={EsitoBiosuisse}
                                value={bioSuisse.createCertificate.result}
                                onChange={(value) => {
                                    //@ts-ignore
                                    const newValue = value !== null ? value.value : null
                                    dispatch(setCreateResult(newValue))
                                }}
                                noOptionsMessage={""}
                            />
                            <MadfarmStaticSelect
                                label="Controllo Bio Suisse"
                                placeholder={'Controllo Bio Suisse'}
                                options={visitOptions}
                                value={bioSuisse.createCertificate.inspectionVisitId}
                                onChange={(value) => {
                                    //@ts-ignore
                                    const newValue = value !== null ? value.value : null
                                    dispatch(setCreateInspectionVisitId(newValue))
                                }}
                                noOptionsMessage={"Nessun risultato trovato"}
                            />
                        </div>
                        <div className='py-6 border-b border-neutral-200 grid grid-cols-1 md:grid-cols-2 gap-4'>
                            <ProtocolSearch
                                label="Invio Checklist a Bio Suisse"
                                type='departure'
                                onSelect={(value) => {
                                    dispatch(setCreateDepartureProtocolSend(value))
                                }}
                            />
                            <ProtocolSearch
                                label="Certificato Bio Suisse"
                                type='entry'
                                onSelect={(value) => {
                                    dispatch(setCreateEntryProtocolResponse(value))
                                }}
                            />
                        </div>
                        <div className='py-6 border-b border-neutral-200'>
                            <TextArea
                                label="Note"
                                onChangeText={(value) => dispatch(setCreateNote(value))}
                                defaultValue={bioSuisse.createCertificate.note}
                            />
                        </div>
                        <div className='py-6 border-b border-neutral-200 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4'>
                            <MadfarmInput
                                label={'Prodotti Certificati'}
                                placeholder="Prodotti Certificati"
                                onChangeText={(text) => dispatch(setCreateCertifiedProducts(text))}
                                defaultValue={bioSuisse.createCertificate.certificatedProducts}
                            />
                            <Calendar
                                label={'Data Inizio validita Certificato'}
                                selected={bioSuisse.createCertificate.validityStartingDate}
                                onChange={(date) => dispatch(setCreateCertificateDate(format(new Date(date), 'yyyy-MM-dd')))}
                            />
                            <Calendar
                                label={'Data Fine validita Certificato'}
                                selected={bioSuisse.createCertificate.validityEndingDate}
                                onChange={(date) => dispatch(setCreateCertificateExpires(format(new Date(date), 'yyyy-MM-dd')))}
                            />
                            <MadfarmStaticSelect
                                label="Condizioni per la certificazione"
                                placeholder={'Condizioni per la certificazione'}
                                value={bioSuisse.createCertificate.certificationConditions === true ? 'SI' : bioSuisse.createCertificate.certificationConditions === false ? 'NO' : undefined}
                                options={yes_no}
                                onChange={(value) => {
                                    //@ts-ignore
                                    const newValue = value !== null ? value.value : null
                                    if (newValue === 'SI')
                                        dispatch(setCreateCondition(true))
                                    if (newValue === 'NO')
                                        dispatch(setCreateCondition(false))
                                }}
                                noOptionsMessage={""}
                            />
                        </div>
                        <div className='pt-6'>
                            <TextArea
                                label="Dettaglio delle Condizioni per la certificazione"
                                onChangeText={(value) => dispatch(setCreateNoteCondition(value))}
                                defaultValue={bioSuisse.createCertificate.certificationConditionsDetail}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Layout >
    )

}